module.exports = __webpack_public_path__ + "img/logo-icon-app.5f1b9fb2.png";